import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParseTimeMinute } from '../Parsers/TEDParseTimeMinute';
import { TEDDisplayTimeMinute } from '../Displayers/TEDDisplayTimeMinute';

class TEDFormatTimeMinute implements IFormatter {
  displayer = TEDDisplayTimeMinute.getInstance();
  parser = TEDParseTimeMinute.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatTimeMinute };
